// extracted by mini-css-extract-plugin
module.exports = {"lang":"Settings_lang__1kysQ"};